import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import { pronunciationModel } from '../step-pronunciation/pronunciation-model';
import { readAloudModel } from '../step-pronunciation/readaloud-model';
import { stepClozeModel } from '../step-cloze/step-cloze-model';
import { stepCardModel } from '../step-card/step-card-model';
import { stepMatchingModel } from '../step-matching/step-matching-model';
import { stepMultipleChoiceModel } from '../step-multiple-choice/step-multiple-choice-model';
import { stepExpertModel } from '../step-expert/step-expert-model';
import { stepSequencingModel } from '../step-sequencing/step-sequencing-model';
import { stepModel } from './step-model';

function initContentStorage(step, activity) {
  switch (true) {
    case stepCardModel.isDocumentStep(step):
      return stepCardModel.parseDocument(step);

    case stepCardModel.isCard(step):
      return stepCardModel.parseCardData(step);

    case stepClozeModel.isCloze(step):
      return stepClozeModel.parseClozeData(step);

    case stepExpertModel.isExtendedSpeaking(step):
      return stepExpertModel.parseExtendedSpeakingData(step);

    case stepExpertModel.isExtendedWriting(step):
      return stepExpertModel.parseExtendedWritingData(step);

    case stepMultipleChoiceModel.isMultipleChoice(step):
      return stepMultipleChoiceModel.parseMultipleChoiceData(step);

    case readAloudModel.isReadAloud(step):
      return readAloudModel.parseReadAloudData(step);

    case pronunciationModel.isPronunciation(step):
      return pronunciationModel.parsePronunciationData(step);

    case stepMatchingModel.isMatching(step):
      return stepMatchingModel.parseMatchingData(step, activity);

    case stepSequencingModel.isSequencingStep(step):
      return stepSequencingModel.parseSequencingData(step);

    default:
      return {};
  }
}

export var withStepData = function withStepData(WrappedComponent) {
  return function (_Component) {
    _inherits(StepDataContainer, _Component);

    function StepDataContainer(props) {
      _classCallCheck(this, StepDataContainer);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props));

      _this.getData = function () {
        var _this$props = _this.props,
            activity = _this$props.activity,
            step = _this$props.step;

        return initContentStorage(step, activity);
      };

      _this.state = {
        data: _this.getData()
      };
      return _this;
    }

    StepDataContainer.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.step.activityStepId !== this.props.step.activityStepId) {
        this.setState({ data: this.getData() });
      }
    };

    StepDataContainer.prototype.render = function render() {
      var _props = this.props,
          activity = _props.activity,
          step = _props.step;

      return React.createElement(WrappedComponent, _extends({}, this.props, {
        data: this.state.data,
        correctIds: step.correct,
        activityStepId: step.activityStepId,
        activityType: activity.activityType,
        behavior: step.behavior,
        inputType: stepModel.getInputType(step),
        evaluationType: stepModel.getEvaluationType(step)
      }));
    };

    return StepDataContainer;
  }(Component);
};